var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "../../Icon";
import Flex from "../../Flex";
import { StyledInfo, StyledTooltip } from "../styled/InfoTooltip";
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        var _a = this.props, tooltip = _a.tooltip, position = _a.position, customIcon = _a.customIcon;
        var Overlay = customIcon ? StyledTooltip : Tooltip;
        return (React.createElement(OverlayTrigger, { placement: position, overlay: React.createElement(Overlay, { id: "tooltip" }, tooltip) }, customIcon ? (React.createElement(Flex, { justifyContent: "flex-end" },
            React.createElement(Icon, { icon: "info" }))) : (React.createElement(StyledInfo, { size: 18 }))));
    };
    default_1.defaultProps = {
        position: "left",
        customIcon: false
    };
    return default_1;
}(PureComponent));
export default default_1;
